module.exports = __webpack_public_path__ + "static/media/vip_ribbon.f6259300.svg";